import React, { forwardRef } from 'react';
import { useStickyScrollbar } from './use-sticky-scrollbar';
import { useAppLayoutContext } from '../internal/context/app-layout-context';
import styles from './styles.css.js';
import mergeRefs from 'react-merge-refs';
export default forwardRef(StickyScrollbar);
function StickyScrollbar(_a, ref) {
    var wrapperRef = _a.wrapperRef, tableRef = _a.tableRef, onScroll = _a.onScroll;
    var scrollbarRef = React.useRef(null);
    var scrollbarContentRef = React.useRef(null);
    var stickyOffsetBottom = useAppLayoutContext().stickyOffsetBottom;
    useStickyScrollbar(scrollbarRef, scrollbarContentRef, tableRef, wrapperRef, stickyOffsetBottom);
    return (React.createElement("div", { ref: mergeRefs([ref, scrollbarRef]), className: styles['sticky-scrollbar'], onScroll: onScroll },
        React.createElement("div", { ref: scrollbarContentRef, className: styles['sticky-scrollbar-content'] })));
}
